import type { TopupRetryResult } from "@/interfaces/topups";
import { apiClient } from "@/lib/apiClient";

/**
 * Nominate a different card for an automated campaign's top-ups.
 *
 * The response carries the RETRY the change triggered, because the client is at the screen: a
 * second decline has to reach them now, while they can reach for another card.
 */
export async function changeTopupCard(
  campaignId: number,
  paymentMethodId: number,
): Promise<TopupRetryResult | null> {
  const { data } = await apiClient.patch<{ retry: TopupRetryResult | null }>(
    `/campaigns/${campaignId}/topup-payment-method`,
    { paymentMethodId },
  );
  return data.retry ?? null;
}
